(function () {
	function pathOnly(src) {
		if (!src || typeof src !== "string") {
			return "";
		}
		try {
			const u = new URL(src, window.location.origin);
			return u.pathname;
		} catch {
			return src.split("?")[0].split("#")[0];
		}
	}

	function urlsFromBoot() {
		// Dark = full wordmark; light = compact favicon (matches _desk_chrome.scss).
		let dark = "/assets/erpnext/images/cybros-logo.png";
		let light = "/assets/erpnext/images/cybros-favicon.png";
		try {
			if (typeof frappe !== "undefined" && frappe.boot) {
				if (frappe.boot.cybros_logo_dark) {
					dark = frappe.boot.cybros_logo_dark;
				}
				if (frappe.boot.cybros_logo_light) {
					light = frappe.boot.cybros_logo_light;
				}
				if (frappe.boot.pos_mode) {
					const posLogo =
						frappe.boot.cybros_logo_dark ||
						frappe.boot.app_logo_url ||
						"/assets/erpnext/images/cybros-pos-logo.png";
					dark = posLogo;
					light = posLogo;
				}
			}
		} catch {
			/* ignore */
		}
		return { dark, light };
	}

	function assetVersion() {
		try {
			if (typeof frappe !== "undefined" && frappe.boot && frappe.boot.cybros_logo_asset_version) {
				return String(frappe.boot.cybros_logo_asset_version);
			}
		} catch {
			/* ignore */
		}
		return "5";
	}

	function busted(absPath) {
		const v = assetVersion();
		const sep = absPath.indexOf("?") === -1 ? "?" : "&";
		return absPath + sep + "v=" + encodeURIComponent(v);
	}

	/** Any Cybros navbar / desk logo asset we may swap. */
	function isCybrosBrandPath(p) {
		return (
			p.includes("cybros-logo.png") ||
			p.includes("cybros-logo-light.png") ||
			p.includes("cybros-favicon.png") ||
			p.includes("cybros-pos-logo") ||
			p.includes("cybros-pos-favicon")
		);
	}

	function isIconOnlyPath(p) {
		return (
			typeof p === "string" &&
			(p.includes("cybros-favicon.png") || p.includes("cybros-pos-favicon"))
		);
	}

	function effectiveTheme() {
		const root = document.documentElement;
		const dt = root.getAttribute("data-theme");
		if (dt === "light" || dt === "dark") {
			return dt;
		}
		const mode = root.getAttribute("data-theme-mode") || "light";
		if (mode === "automatic") {
			try {
				return window.matchMedia("(prefers-color-scheme: dark)").matches
					? "dark"
					: "light";
			} catch {
				return "light";
			}
		}
		return mode === "dark" ? "dark" : "light";
	}

	function syncCybrosLogos() {
		const { dark, light } = urlsFromBoot();
		const posMode =
			typeof frappe !== "undefined" && frappe.boot && Boolean(frappe.boot.pos_mode);
		// Company logo as tab icon; the POS subdomain bundle sets its own.
		const favicon = !posMode && typeof frappe !== "undefined" && frappe.boot?.cybros_favicon;
		if (favicon) {
			document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach((link) => {
				if (link.getAttribute("href") !== favicon) {
					link.setAttribute("href", favicon);
				}
			});
		}
		// POS: always full logo. Main ERP: light theme uses compact icon.
		const wantIcon = posMode ? false : effectiveTheme() === "light";
		const nextPath = wantIcon ? light : dark;
		const nextPathOnly = pathOnly(nextPath);
		// Navbar / app brand only — never module or workspace sidebar icons.
		const sel = [
			"#brand-logo",
			"img.cybros-navbar-logo",
			".navbar .header-logo img",
			".navbar img[src*='cybros-logo']",
			".navbar img[src*='cybros-favicon']",
			".navbar img[src*='cybros-pos-logo']",
			".navbar img[src*='cybros-pos-favicon']",
		].join(", ");
		const seen = new Set();
		document.querySelectorAll(sel).forEach((el) => {
			if (el.tagName !== "IMG" || seen.has(el)) {
				return;
			}
			seen.add(el);
			if (
				el.closest(
					".desk-sidebar, .workspace-sidebar, .body-sidebar, .sidebar-item-icon, .standard-sidebar-item"
				)
			) {
				return;
			}
			const cur = el.getAttribute("src") || "";
			const full = el.src || "";
			const p = pathOnly(cur) || pathOnly(full);
			if (!isCybrosBrandPath(p) && !el.id?.includes("brand") && !el.classList.contains("cybros-navbar-logo")) {
				return;
			}
			if (p === nextPathOnly) {
				return;
			}
			el.src = busted(nextPath);
		});
	}

	let t = 0;
	function syncDebounced() {
		if (t) {
			cancelAnimationFrame(t);
		}
		t = requestAnimationFrame(() => {
			t = 0;
			syncCybrosLogos();
		});
	}

	syncCybrosLogos();

	if (typeof MutationObserver !== "undefined") {
		const mo = new MutationObserver(syncDebounced);
		mo.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ["data-theme", "data-theme-mode"],
		});
		if (document.body) {
			mo.observe(document.body, { childList: true, subtree: true });
		} else {
			document.addEventListener("DOMContentLoaded", () => {
				mo.observe(document.body, { childList: true, subtree: true });
				syncCybrosLogos();
			});
		}
	}

	try {
		window
			.matchMedia("(prefers-color-scheme: dark)")
			.addEventListener("change", syncDebounced);
	} catch {
		/* ignore */
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", syncCybrosLogos);
	} else {
		syncCybrosLogos();
	}

	window.CybrosLogoTheme = { sync: syncCybrosLogos };

	if (typeof window.frappe !== "undefined" && frappe.ready) {
		frappe.ready(() => {
			syncCybrosLogos();
			if (frappe.router && frappe.router.on) {
				frappe.router.on("change", () => setTimeout(syncCybrosLogos, 0));
			}
		});
	}
})();
